
<script lang="ts">
	import {onMount} from 'svelte';
	import Fa from "svelte-fa/dist/svelte-fa";
	import { faImage } from "@fortawesome/free-solid-svg-icons";
	// util
	import { isValidURL } from "../helpers/utils";

	// source to load
	export let src:string = null;

	// image element to be exported back
	export let image: HTMLImageElement;

	let imageLoading = null;

	onMount(()=>{
		 if(src){
			 urlLoader(src);
		 }
	})

	/**
	 * This is for handling file input
	 * @param e
	 */
	function fileChangeEvent(e) {
		// read file
		const file = e.target.files[0];
		const reader = new FileReader();

		const img = new Image();

		img.onload = () => {
			image = img;
		};

		reader.onloadend = () => {
			img.src = reader.result as string;
		};

		reader.onerror = () => {
			console.error("Unable to read image");
		};
		reader.readAsDataURL(file);
	}

	let urlValidationMessage = "";


	/**
	 * To capture user input url.
	 * @param e
	 */
	function inputHandler(e) {
		urlValidationMessage = null;
		src = e.target.value;
		if (!isValidURL(src)) {
			urlValidationMessage = "Input a valid URL.";
			return;
		}
		urlLoader(src);
	}

	/**
	 * This is for handling url input
	 * @param e
	 */
	function urlLoader(url:string) {
		imageLoading = true;
		// fetch image
		fetch(url, { mode: "cors" })
			.then((response) => {
				if (response.status !== 200) {
					throw new Error("Unable to fetch the image.");
				}
				return response;
			})
			.then(data=>data.blob())
			.then((blob) => {
				var img = new Image();
				img.onload = () => {
					image = img;
				};
				img.src = URL.createObjectURL(blob);
			})
			.catch((err) => {
				urlValidationMessage = err.message;
			})
			.finally(() => {
				imageLoading = false;
			});

	}
</script>

<style type="text/scss">
	@import "FormInput";
</style>
<form class="form-elements" class:hidden="{src !== ''}">
	<div class="cform-control">
		<label for="upload">
			<input type="file" id="upload" hidden on:change={fileChangeEvent} />
			<Fa icon={faImage} />
			<span>Choose Photo</span>
		</label>
	</div>
	<div class="cform-control">
		<div class="horizontal-divider"></div>
		<div>or</div>
		<div class="horizontal-divider"></div>
	</div>
	<div class="cform-control">
		<input type="text" placeholder="Paste image URL" on:input={inputHandler}/>
	</div>
</form>
<div class:visible="{ imageLoading == true}" class="card--skeleton">
	<span> Loading image... </span>
</div>
<p class="error">
	{#if urlValidationMessage}{urlValidationMessage}{/if}
</p>